module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.flowPaperContent) ? _c('div', [_c('div', {
    staticClass: "x-wrapper x-absolute",
    on: {
      "click": function($event) {
        _vm.handleClose()
      }
    }
  }, [_c('icon', {
    staticClass: "close-icon pointer",
    attrs: {
      "name": "close",
      "scale": "1.5"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.books), function(myBook) {
    return _c('div', {
      key: myBook.id,
      staticClass: "responsive-iframe"
    }, [_c('iframe', {
      attrs: {
        "src": _vm.$store.state.urlLink + myBook.bookId + '/',
        "frameborder": "0",
        "allowfullscreen": ""
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.flowPaperContent) ? _c('div', [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('div', {
    staticClass: "bk-content"
  }, _vm._l((_vm.books), function(myBook) {
    return _c('div', {
      key: myBook.id,
      staticClass: "book-pic-bg"
    }, [_c('a', {
      attrs: {
        "id": "book-pic-wrapper"
      }
    }, [_c('img', {
      staticClass: "pic-element",
      attrs: {
        "src": _vm.$store.state.urlLink + myBook.bookId + '.png'
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "book-pic-desc"
  }, [_c('div', {
    staticClass: "book-pic-details"
  }, [_c('h5', {
    attrs: {
      "id": "book-title-font"
    }
  }, _vm._l((_vm.books), function(myBook) {
    return _c('strong', {
      key: myBook.id
    }, [_vm._v("\n                  " + _vm._s(myBook.bookName) + "\n                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bk-pic-nav"
  }, _vm._l((_vm.books), function(myBook) {
    return _c('ul', {
      key: myBook.id,
      staticClass: "bk-pic-nav-info"
    }, [_c('li', {
      staticClass: "bk-pic-nav-item"
    }, [_vm._v(_vm._s(myBook.datePublished))]), _vm._v(" "), _c('li', {
      staticClass: "bk-pic-nav-item"
    }, [_vm._v("Language : " + _vm._s(myBook.language))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "bk-btn-desc"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.statusLogin),
      expression: "!statusLogin"
    }],
    staticClass: "bk-button-nav"
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(255, 255, 255, 0.2)'),
      expression: "'rgba(255, 255, 255, 0.2)'"
    }],
    attrs: {
      "id": "bk-btn-subscribe"
    },
    on: {
      "click": function($event) {
        _vm.handleLogin()
      }
    }
  }, [_vm._v("LOGIN TO READ")]), _vm._v(" "), _c('h3')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }],
    staticClass: "bk-button-nav"
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(255, 255, 255, 0.2)'),
      expression: "'rgba(255, 255, 255, 0.2)'"
    }],
    attrs: {
      "id": "bk-btn-all-content"
    },
    on: {
      "click": function($event) {
        _vm.handleFlowPaper()
      }
    }
  }, [_vm._v("READ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "id": "bk-book-text-wrapper"
    }
  }, [_c('div', {
    staticClass: "bk-pic-text-detail"
  }, [_c('div', {
    staticClass: "truncate truncate1",
    class: {
      toggleReadMore: _vm.readMoreActive
    },
    staticStyle: {
      "color": "#fff"
    }
  }, _vm._l((_vm.books), function(myBook) {
    return _c('p', {
      key: myBook.id
    }, [_vm._v(" \n                " + _vm._s(myBook.description) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "white-divider"
  }, [_c('span', {
    staticClass: "divider-ball",
    class: {
      flipBall: _vm.readMoreActive
    },
    on: {
      "click": function($event) {
        _vm.readMoreActive = !_vm.readMoreActive
      }
    }
  }, [_c('span', {
    staticClass: "divider-icon"
  })])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5257a8fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ViewContent.vue
// module id = 1694
// module chunks = 1